import { AuthenticationResponse, ChangeUserAccountResponse, UsersListResponse } from "../../profileTypes"

export function isChangeUserAccountResponse(response?: ChangeUserAccountResponse): response is AuthenticationResponse {
    return (response as AuthenticationResponse).authenticationResult !== undefined
}

export function isUserTypeResponse(response?: ChangeUserAccountResponse): response is UsersListResponse {
    return (response as UsersListResponse).userTypes !== undefined
}
